export default {"src":"/_next/static/media/ppp.fcd7467b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};